// Marchio di prodotto al centro della barra superiore. File scelto dall'azienda il 17/09/2026:
// `public/logo_soc_platform_band.svg` (nextgendis.svg), una FASCIA 750×36 — il logo su una banda
// blu sfumata a trasparente ai due lati — non un marchio compatto. Conseguenze pratiche:
//  - l'altezza è vincolata: a h-10 (40px) la fascia è larga ~830px e, verificato in browser, sta
//    fra i contatori e il menu utente sia a 1500 che a 1366px di schermo; più alta non ci sta;
//  - il marchio dentro la fascia è più piccolo del cubo bianco del file compatto
//    (`logo_soc_platform_light.svg`, 750×165, tenuto in public/ come alternativa: basta cambiare
//    src e riportare le altezze a h-12/h-9);
//  - le sfumature laterali sono pensate per fondo scuro, ed è il caso dell'header (sempre
//    bg-gray-900, anche sulle pagine chiare).
// Il JPEG originale (`logo_soc_platform.jpg`, con placchetta bianca) non è più usato.
// Per vederlo più grande senza allargare tutto (richiesta del 17/09): la fascia viene alzata a
// h-14 (56px, quindi ~1170px di larghezza) e RITAGLIATA da un contenitore a larghezza fissa,
// centrato. Si tagliano solo le code sfumate a trasparente; il marchio, che occupa il quarto
// centrale della fascia, resta intero e passa da ~25 a ~34px di altezza. La larghezza del
// contenitore è limitata anche in vw per non toccare contatori e menu utente su schermi stretti.
export default function SocPlatformLogo({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`${compact ? 'h-10 w-[420px]' : 'h-14 w-[560px]'} max-w-[42vw] overflow-hidden flex items-center justify-center`}
      // Il ritaglio taglierebbe le code sfumate lasciando due bordi netti: la maschera li sfuma di nuovo.
      style={{ maskImage: 'linear-gradient(to right, transparent, black 22%, black 78%, transparent)', WebkitMaskImage: 'linear-gradient(to right, transparent, black 22%, black 78%, transparent)' }}>
      <img
        src="/logo_soc_platform_band.svg"
        alt="SOC Platform by NextGen Distribution"
        className={`${compact ? 'h-10' : 'h-14'} w-auto max-w-none select-none`}
        draggable={false}
      />
    </div>
  );
}
